namespace $.$$ {

	type $shm_hitalama_map_page_layout_drop_candidate = {
		layout: string
		pos: number
		distance: number
		depth: number
		z: number
	}

	const $shm_hitalama_map_page_container_types = new Set< $shm_hitalama_map_widget_def_type_name >([
		'group',
		'layout_vert',
		'layout_hor',
		'notebook',
		'notebook2',
	])

	type $shm_hitalama_map_page_autobackup_state = {
		timer?: $mol_after_timeout
		last_json: string
		pending_json: string
	}
	
	export class $shm_hitalama_map_page extends $.$shm_hitalama_map_page {

		journal_benchmark_started_run = ''
		journal_benchmark_stopped_run = ''
		file_dragover_document_listener_obj: $mol_dom_listener | null = null
		file_drop_document_listener_obj: $mol_dom_listener | null = null
		static autobackup_states = new Map< string, $shm_hitalama_map_page_autobackup_state >()

		auto() {
			return [
				... super.auto(),
				this.file_dragover_document_listener(),
				this.file_drop_document_listener(),
			]
		}

		map(): $shm_hitalama_map {
			return this.entity().cast( $shm_hitalama_map )
		}

		Map_page() {
			return this
		}

		journal_snapshots() {
			return this.map().Journal_snapshots()?.remote()
		}

		journal_benchmark_auto() {
			const journal = this.journal_snapshots()
			if( !journal ) return null

			const run = journal.run_id()
			const started = journal.write_started()
			const stopped = journal.write_stopped()

			if( started && run && this.journal_benchmark_started_run !== run ) {
				this.journal_benchmark_started_run = run
				$shm_hitalama_map_journal_recorder.clear( this.map() )
				journal.client_add()
				$shm_hitalama_notifications.info( 'Бенчмарк начат' )
			}

			if( started && !stopped && run ) {
				$shm_hitalama_notifications.show({
					id: `hitalama_benchmark_clients_${ this.map().link().str }`,
					type: 'info',
					timeout: 0,
					message: `Подключено клиентов: ${ journal.clients().length }`,
				})
			}

			if( stopped && run ) {
				$shm_hitalama_map_journal_recorder.snapshot_write_if_requested( this.map() )
				$shm_hitalama_map_journal_analysis_widgets.ensure_if_ready( this.map(), journal )
				const clients = journal.clients().length
				const written = journal.snapshots_written_count()
				$shm_hitalama_notifications.close( `hitalama_benchmark_clients_${ this.map().link().str }` )
				if( written < clients || clients === 0 ) {
					$shm_hitalama_notifications.show({
						id: `hitalama_benchmark_collect_${ this.map().link().str }`,
						type: 'info',
						timeout: 0,
						message: `Сбор журналов ${ written }/${ clients }`,
					})
				} else {
					$shm_hitalama_notifications.close( `hitalama_benchmark_collect_${ this.map().link().str }` )
				}
				if( this.journal_benchmark_stopped_run !== run ) {
					this.journal_benchmark_stopped_run = run
					$shm_hitalama_notifications.success( 'Бенчмарк завершен' )
				}
			}

			return null
		}
		
		@ $mol_action
		cut() {
			$shm_hitalama_profile.current()?.cut_map( this.map().link() )
		}
		
		@ $mol_mem
		exported_json() {
			return JSON.stringify( this.map().serialized() )
		}

		@ $mol_mem
		exported_blob() {
			const blob = new Blob([ this.exported_json() ], { type: "application/json" });
			return blob
		}

		@ $mol_action
		widget_to_top( ref: $giper_baza_link ) {
			this.widget_z( ref, this.widgets_count() - 1 )
		}

		@ $mol_action
		widget_to_bottom( ref: $giper_baza_link ) {
			this.widget_z( ref, 0 )
		}

		widgets_count() {
			return this.map().Widgets_list()?.remote_list().length ?? 0
		}

		@ $mol_mem_key
		widget_z( ref: $giper_baza_link, next?: number ): number {
			return this.widget_by_link( ref ).z( next )
		}

		widget_view( ref: $giper_baza_link ): $shm_hitalama_map_widget_float {
			return this.Widget( ref ).Sub() as $shm_hitalama_map_widget_float
		}

		@ $mol_mem_key
		widget_by_link( link: $giper_baza_link ) {
			return $giper_baza_glob.Pawn( link, $shm_hitalama_map_widget )
		}

		@ $mol_mem_key
		widget_type( link: $giper_baza_link ) {
			return this.widget_by_link( link ).type()
		}

		pos_by_link: Map< string, number > = new Map
		widgets_filtered_notebook2: $shm_hitalama_map_widget[] = []
		widgets_filtered_types: $shm_hitalama_map_widget_def_type_name[] = []
		@ $mol_mem
		widgets_filtered() {
			const list = this.map().Widgets_list()?.remote_list() ?? []
			let notebook2: $shm_hitalama_map_widget[] = []
			let types: $shm_hitalama_map_widget_def_type_name[] = []
			let filtered: $shm_hitalama_map_widget[] = []
			let has_notebook = false
			
			for( let i = 0; i < list.length; ++i ) {
				const w = list[ i ]
				const link = w.link()
				const link_str = link.str
				this.pos_by_link.set( link_str, i )
				const type = this.widget_type( link )
				
				if( !this.viewport_frames_visible() && type == 'viewport_frame' ) continue
				if( type == 'notebook' ) has_notebook = true
				// if( b.type() == 'code_js' ) return []
				if( type == 'notebook2' ) notebook2.push( w )
				types.push( type )
				filtered.push( w )
			}

			if( has_notebook ) {
				const filtered_next: $shm_hitalama_map_widget[] = []
				const types_next: $shm_hitalama_map_widget_def_type_name[] = []
				const notebook2_next: $shm_hitalama_map_widget[] = []
				
				for( let i = 0; i < filtered.length; ++i ) {
					const widget = filtered[ i ]
					if( widget.container_widget()?.type() == 'notebook' ) continue
					const type = types[ i ]
					if( type == 'notebook2' ) notebook2_next.push( widget )
					filtered_next.push( widget )
					types_next.push( type )
				}
				
				filtered = filtered_next
				types = types_next
				notebook2 = notebook2_next
			}
			
			this.widgets_filtered_notebook2 = notebook2
			this.widgets_filtered_types = types
			return filtered
		}

		@ $mol_mem
		widgets_view(): readonly $shm_hitalama_map_widget_any[] {
			const widgets = this.widgets_filtered()
			const views: $shm_hitalama_map_widget_any[] = []
			for( let index = 0; index < widgets.length; ++index ) {
				const widget = widgets[ index ]
				const view = this.Widget( widget.link() ) as $shm_hitalama_map_widget_any
				const type = this.widgets_filtered_types[ index ] ?? widget.type()
				if( type != 'text' && view.code_widget_hidden() ) continue
				views.push( view )
			}
			return views
		}

		layout_drop_types() {
			return new Set([ 'layout_vert', 'layout_hor' ])
		}

		layout_depth( widget: $shm_hitalama_map_widget ) {
			let depth = 0
			let parent = widget.container_widget()
			while( parent ) {
				depth += 1
				parent = parent.container_widget()
			}
			return depth
		}

		layout_drop_candidates(): readonly $shm_hitalama_map_page_layout_drop_candidate[] {
			const types = this.layout_drop_types()
			return this.widgets_filtered().flatMap( widget => {
				if( !types.has( widget.type() ) ) return []

				const view = this.Widget( widget.link() ).Sub() as any
				const candidate = view.drop_candidate?.() as $shm_hitalama_map_page_layout_drop_candidate | null | undefined
				if( !candidate ) return []

				return [{
					... candidate,
					depth: this.layout_depth( widget ),
					z: widget.z(),
				}]
			} )
		}

		layout_drop_best() {
			const candidates = this.layout_drop_candidates()
			return candidates.toSorted( ( left, right )=> {
				return ( right.depth - left.depth )
					|| ( right.z - left.z )
					|| ( left.distance - right.distance )
			} )[0] ?? null
		}

		@ $mol_mem
		notebook2_adds(): readonly $.$shm_hitalama_map_widget_float_notebook2_adds[] {
			this.widgets_filtered()
			return this.widgets_filtered_notebook2.map( widget => {
				const notebook = this.Widget( widget.link() ).Sub() as $shm_hitalama_map_widget_float_notebook2
				return notebook.Adds()
			} )
		}

		selectbox_view() {
			return this.selected_links().length > 1 ? super.selectbox_view() : []
		}

		@ $mol_mem
		widgets_clear() {
			this.map().Widgets_list()?.remote_list( [] )
		}

		@ $mol_mem
		stickable() {
			if( this.selected_links().length > 1 ) return false
			if( this.Pane().drag_mode_enabled() ) return false
			return true
		}

		sticks_threshold() {
			return this.$.$shm_hitalama_settings.stick_px()
		}

		widget_float_resizer_size_css() {
			return `${ this.$.$shm_hitalama_settings.widget_float_resizer_size() }px`
		}

		@ $mol_mem_key
		sticks( ref: $giper_baza_link ) {
			const widget = this.Widget(ref).Sub()
			// if( this.widget_by_link(ref).container_widget() ) return { sticks_x:[], sticks_y:[] }

			const sticks_x: number[] = [0]
			const sticks_y: number[] = [0]

			const x_min = widget.left()
			const x_max = widget.left() + widget.width()
			const y_min = widget.top()
			const y_max = widget.top() + widget.height()

			const threshold = this.sticks_threshold()
			const widgets = this.widgets_view().map( view => view.Sub() as $shm_hitalama_map_widget_float )
			widgets.forEach( w => {
				// if( w.widget().container_widget() ) return
				if( w.widget().link() == ref ) return

				const x1 = w.left()
				if( x1 - x_max > threshold ) return
				const y1 = w.top()
				if( y1 - y_max > threshold ) return
				const x2 = w.left() + w.width()
				if( x_min - x2 > threshold ) return
				const y2 = w.top() + w.height()
				if( y_min - y2 > threshold ) return

				sticks_x.push( x1, x2 )
				sticks_y.push( y1, y2 )
			} )

			return { sticks_x, sticks_y }
		}

		@ $mol_mem_key
		sticks_x( ref: $giper_baza_link ) {
			return this.sticks(ref).sticks_x
		}

		@ $mol_mem_key
		sticks_y( ref: $giper_baza_link ) {
			return this.sticks(ref).sticks_y
		}

		inner_widgets_deep( link: $giper_baza_link ): $giper_baza_link[] {
			return this.widget_by_link( link ).widgets()?.flatMap( w => {
				return [
					w.link(),
					... this.inner_widgets_deep( w.link() )
				]
			} )
		}

		@ $mol_mem_key
		drags_synced( link: $giper_baza_link ): readonly ( $.$rise_drag )[] {
			return [
				...this.selected_links().flatMap( slink => slink.str == link.str ? [] : [this.Widget(slink).Sub().Drag()] ),
				// ...this.inner_widgets_deep( link ).map( l => {
				// 	return this.Widget(l).Sub().Drag()
				// } )
			]
		}
		@ $mol_mem
		some_transforming(): boolean {
			return this.selected_links().some( ref => this.Widget(ref).Sub().transforming() )
		}

		// @ $mol_mem
		// pull_drags_synced() {
		// 	return this.widgets_view().map( b => this.drags_synced( b.widget().link() ) )
		// }

		// not persistent on purpose, for shift_pressed by default
		@ $mol_mem
		multi_select_enabled( next?: boolean ) {
			return next ?? this.Pane().shift_pressed()
		}

		ctrl_pressed() {
			return this.Pane().ctrl_pressed()
		}

		shift_pressed() {
			return this.Pane().shift_pressed()
		}

		@ $mol_mem_key
		selected( link: $giper_baza_link, next?: boolean ): boolean {
			if( next === undefined ) return Boolean( this.selected_links().find( l => l.str == link.str ) )

			if( next ) {
				if( this.multi_select_enabled() ) {

					const set = new Set([ ...this.selected_links(), link ])
					this.selected_links( [...set.values()] )

				} else if( ! this.selected_links().find( l => l.str == link.str ) ) {

					this.selected_links( [ link ] )
				}

			} else {
				this.selected_links( 
					this.Pane().shift_pressed() ? this.selected_links().filter( l => l.str !== link.str ) : []
				)
			}

			return next
		}

		@ $mol_mem_key
		hovered( ref: $giper_baza_link, next?: boolean ): boolean {
			if( next == true ) this.hovered_link( ref )
			if( next == false && this.hovered_link() == ref ) this.hovered_link( null )
			return next ?? false
		}

		@ $mol_mem_key
		hover_styled( ref: $giper_baza_link ): boolean {
			if( this.hovered( ref ) ) return true

			if( $shm_hitalama_map_page_container_types.has( this.widget_type( ref ) ) ) {
				const inner_hovered = this.widget_by_link( ref ).widgets().some( w => {
					return this.Widget(w.link()).Sub().hovered()
				} )
				if( inner_hovered ) return true
			}

			if( this.Dragger().widget() ) {
				return ref == this.Dragger().widget()?.widget().link()
			}

			return false
		}

		@ $mol_mem
		prevent_shift_y() {
			const ref = this.hovered_link()
			if( !ref ) return false
			return this.widget_view( ref ).has_scrollbar_y() ?? false
		}

		@ $mol_mem
		prevent_shift_x() {
			const ref = this.hovered_link()
			if( !ref ) return false
			return this.widget_view( ref ).has_scrollbar_x() ?? false
		}

		select_resize() {
			const [left, top] = this.to_real_pos( this.select_rect_pos() )

			let [width, height] = this.select_rect_size()
			const zoom = this.zoom()
			;width /= zoom
			;height /= zoom

			const widgets = this.widgets_view().map( view => view.Sub() as $shm_hitalama_map_widget_float ).filter( w => {
				if( w.widget().container_widget() ) return

				if( left + width < w.left() ) return
				if( left > w.left() + w.width() ) return

				let widget_top = w.top()
				let widget_height = w.height()
				// if( ['layout_vert','viewport_frame'].includes( w.widget().type() ) ) {
				// 	if( w.widget().hide_head_tools() ) return
				// 	widget_top = widget_top - 40
				// 	widget_height = 40
				// }
				if( top + height < widget_top ) return
				if( top > widget_top + widget_height ) return
				return true
			} )

			this.selected_links( widgets.map( b => b.widget().link() ) )
		}

		deselect_all() {
			this.selected_links([])
		}

		back_event_pointerdown_last?: PointerEvent
		back_event_pointerdown( event: PointerEvent ) {
			this.back_event_pointerdown_last = event
			if( event.button != 2 ) this.deselect_all()
			this.select_start( event )
		}

		back_event_contextmenu( event: PointerEvent ) {
			event.preventDefault()
			if( this.tool_mode() ) return

			if( !this.back_event_pointerdown_last
				|| $shm_hitalama_is_panning( this.back_event_pointerdown_last, event )
			) return
			
			this.contextmenu_body( [ this.Back_contextmenu_body() ] )
			this.contextmenu_pos( [event.offsetX, event.offsetY] )
			this.contextmenu_showed( true )
		}

		@ $mol_mem_key
		widget_event_contextmenu( ref: $giper_baza_link, event?: PointerEvent ) {
			const Body = this.widget_view( ref ).Contextmenu_body()
			if( !Body ) return
			this.contextmenu_body( [ Body ] )
			this.contextmenu_pos( this.client_pos_to_pane_pos( [event!.clientX, event!.clientY] ) )
			this.contextmenu_showed( true )
		}

		touch_event_disabled() {
			return this.camera_locked() || Boolean( this.$.$mol_state_arg.value( 'fullscreen_widget' ) )
		}

		widget_tools_hidden() {
			return this.tool_mode() !== ''
		}

		@ $mol_mem
		viewport_to_frame( reset?: null ) {
			if( !this.slideshow_enabled() ) return

			const frame_str = this.slideshow_frame_str()
			this.go_to_frame_by_num( frame_str )
		}

		@ $mol_action
		now() {
			return (new $mol_time_moment)
		}

		autobackup_state() {
			const key = this.map().link().str
			let state = $shm_hitalama_map_page.autobackup_states.get( key )
			if( state ) return state

			state = {
				last_json: '',
				pending_json: '',
			}
			$shm_hitalama_map_page.autobackup_states.set( key, state )
			return state
		}

		backup_form_data( chat_id: string, json: string ) {
			const text = this.map().title() + '_' + this.now().valueOf()

			const formData = new FormData()
			formData.append( 'chat_id', chat_id )

			const blob = new Blob([ json ], { type: "application/json" })
			formData.append( 'document', blob, text + '.json' )

			return formData
		}

		autobackup_debounce() {
			return 1000
		}

		@ $mol_mem
		autobackup( next?: any ) {
			const backup_time = Number( this.backup_time() ) || 1
			$mol_state_time.now( backup_time * 60000 )

			const token = this.$.$shm_hitalama_profile.current()?.secret_val( 'backup_bot_token' ).trim()
			const chat_id = this.$.$shm_hitalama_profile.current()?.secret_val( 'backup_chat_id' ).trim()
			if( !token || !chat_id ) return

			const json = this.exported_json()
			const state = this.autobackup_state()
			if( json === state.last_json || json === state.pending_json ) return

			state.timer?.destructor()
			state.pending_json = json
			state.timer = new this.$.$mol_after_timeout(
				this.autobackup_debounce(),
				()=> this.autobackup_send( token, chat_id, json ),
			)
		}

		autobackup_send( token: string, chat_id: string, json: string ) {
			const state = this.autobackup_state()
			state.timer = undefined
			if( json === state.last_json ) return Promise.resolve( null )

			const url = `https://api.telegram.org/bot${token}/sendDocument`
			return fetch( url, {
				method: 'POST',
				body: this.backup_form_data( chat_id, json ),
			} )
			.then( response => response.json().then( data => ({ response, data }) ) )
			.then( ({ response, data }) => {
				if( !response.ok || !data.ok ) throw new Error( data.description || response.statusText || 'Не удалось сохранить backup в Telegram' )
				state.last_json = json
				if( state.pending_json === json ) state.pending_json = ''
				return data
			} )
			.catch( error => {
				if( state.pending_json === json ) state.pending_json = ''
				console.error( error )
				return null
			} )
		}

		@ $mol_action
		go_to_widget( ref: $giper_baza_link ) {
			const widget = this.widget_view( ref )

			const c_x = widget.left() + widget.width()/2
			const c_y = widget.top() + widget.height()/2
			this.Pane().center_to_point( [c_x, c_y] )
		}

		@ $mol_action
		go_to_frame_by_num( frame_num: string ) {

			const frame = this.map().viewport_frames().find( b => {
				return b.text() === frame_num
			} )

			if( !frame ) return
			const widget = this.widget_view( frame.link() )

			this.Pane().box_in_viewport( new $mol_vector_2d( 
				new $mol_vector_range( widget.left(), widget.left()+widget.width() ),
				new $mol_vector_range( widget.top(), widget.top()+widget.height() ),
			) )
		
		}

		@ $mol_action
		set_frame( ref: string ) {
			const frame = this.map().widget( ref )
			this.slideshow_frame( Number(frame.text()) )

			if( ! this.slideshow_enabled() ) {
				this.go_to_frame_by_num( frame.text() )
			}
		}

		@ $mol_mem
		contextmenu_pos( next?: readonly [number, number] ) {
			if( next === undefined ) return [0,0]
			return next
		}

		@ $mol_mem
		contextmenu_pos_shifted() {
			const pos = [ ... this.contextmenu_pos() ]

			const menu_height = this.Context_menu().minimal_height()
			const page_height = this.dom_node()?.getBoundingClientRect().height ?? Infinity	
			const edge_gap = 5

			if( (pos[1] + menu_height) > page_height ) {
				pos[1] = pos[1] - menu_height
			}
			pos[1] = Math.max( edge_gap, pos[1] )

			return pos
		}

		@ $mol_mem
		contextmenu_real_pos() {
			return this.to_real_pos( this.contextmenu_pos() )
		}
		
		contextmenu_visible(): readonly ( any )[] {
			return this.contextmenu_showed() ? super.contextmenu_visible() : []
		}

		async image_blob_size( blob: Blob ) {
			const bmp = await createImageBitmap( blob )
			const { width, height } = bmp
			bmp.close() // free memory
			return { width, height }
		}

		@ $mol_action
		image_add( blob: Blob, size: { width: number, height: number } ) {
			const pos =  this.get_pointer_pos()

			const widget = this.map().widget_add( 'image', pos, size.width, size.height )
			widget?.Image(null)?.blob( blob )
			return widget
		}

		async image_add_pasted( blob: Blob ) {
			const size = await this.image_blob_size( blob )
			return this.image_add( blob, size )
		}

		@ $mol_action
		paste_text( text: string ) {
			const pos =  this.get_pointer_pos()
			const widget = $shm_hitalama_map_widget_presets.for_map( this.map() ).text( pos, text )
			return widget
		}

		@ $mol_action
		get_pointer_pos() {
			return this.to_real_pos( this.pointer_pos() )
		}

		@ $mol_action
		get_center_pos() {
			const rect = $mol_wire_sync( this.Pane() ).view_rect_ensured()
			if( !rect ) return
			const { width, height } = rect
			const pos = this.to_real_pos( [width/2,height/2] )
			return pos
		}

		@ $mol_mem
		scale_percent() {
			return (this.zoom() * 100).toFixed(2) + '%'
		}
		
		@ $mol_mem
		presences() {
			const map = this.map()
			return map.Presences()?.remote() ?? map.Presences(null)?.ensure( [[ null, $giper_baza_rank_make( 'post', 'just' ) ]] )
		}

		@ $mol_mem
		presence() {
			const profile = $shm_hitalama_profile.current()
			const id = profile?.link().toString()!
			const presence = this.presences()!.key( id, 'auto' ).ensure( null )
			presence?.Profile(null)?.remote( profile )
			return presence
		}

		@ $mol_mem
		send_presence_pos_atom() {
			new $mol_wire_atom( 'send_cursor_pos', ()=> {
				$mol_state_time.now(50)
				this.presence()?.Pos(null)?.val( this.get_pointer_pos() as number[] )
			} ).fresh()
		}

		Dragger_set_pos() {
			return this.Dragger().set_pos()
		}

		dragger() {
			return this.Dragger().widget() ? super.dragger() : []
		}

		@ $mol_mem_key
		presence_pos( key: string ) {
			const presence = this.presences()?.key( key ).remote()
			return presence?.Pos()?.val()
		}

		@ $mol_mem
		cursors(): readonly ( any )[] {
			return [] //temp hide

			const profile = $shm_hitalama_profile.current()
			const id = profile?.link().toString()!

			return this.presences()?.keys().flatMap( key => {
				// return [ this.Cursor(key) ]
				return key == id ? [] : [ this.Cursor(key) ]
			} ) ?? []
		}

		tg_send_file() {
		}

		drop_files_cache = new WeakMap< DataTransfer, File[] >()
		drop_file_positions_cache = new WeakMap< DragEvent, [ number, number ][] >()

		file_add( file: File, pos: [ number, number ] ) {
			const map = this.map()
			const map_file = map.Files(null)?.make( map.land() )!
			map_file?.write( file )

			const widget = map.widget_add( 'file', pos, 350, 200 )!
			widget.File(null)!.remote( map_file )
			widget.title( file.name )
			if( $shm_hitalama_map_widget_entity_app.archive( map_file ) ) widget.app()
			return widget
		}

		files_from_drop( transfer?: DataTransfer | null ) {
			if( !transfer ) return [] as File[]
			const cached = this.drop_files_cache.get( transfer )
			if( cached ) return cached

			const items = transfer.items
			const item_files = [] as File[]
			const transfer_files = Array.from( transfer.files )

			for( let i = 0; i < items.length; ++i ) {
				const item = items[ i ]
				if( item.kind !== 'file' ) continue

				const file = item.getAsFile()
				if( file ) item_files.push( this.file_from_drop_stable( file, transfer_files[ i ] ) )
			}

			const files = item_files.length
				? item_files
				: transfer_files.map( file => this.file_stable( file ) )
			this.drop_files_cache.set( transfer, files )
			return files
		}

		file_from_drop_stable( file: File, fallback?: File ) {
			const source = file.name || file.size ? file : ( fallback ?? file )
			return this.file_stable( source )
		}

		file_stable( file: File ) {
			return new File( [ file ], file.name, {
				type: file.type,
				lastModified: file.lastModified,
			} )
		}

		drop_file_positions( event: DragEvent, count: number ) {
			const cached = this.drop_file_positions_cache.get( event )
			if( cached ) return cached

			const pos = this.to_real_pos( this.client_pos_to_pane_pos( [ event.clientX, event.clientY ] ) )
			const positions = Array.from(
				{ length: count },
				( _, index )=> [ pos[0] + index*20, pos[1] + index*20 ] as [ number, number ],
			)
			this.drop_file_positions_cache.set( event, positions )
			return positions
		}

		@ $mol_action
		event_drop( event: DragEvent ) {
			event.preventDefault()

			const files = this.files_from_drop( event.dataTransfer )
			if( files.length == 0 ) return

			const positions = this.drop_file_positions( event, files.length )
			files.forEach( ( f, i ) => this.file_add( f, positions[ i ] ) )
		}

		document() {
			return this.$.$mol_dom_context.document
		}

		file_drag_has_files( event: DragEvent ) {
			const transfer = event.dataTransfer
			if( !transfer ) return false
			if( Array.from( transfer.types ?? [] ).includes( 'Files' ) ) return true
			if( Array.from( transfer.files ?? [] ).length ) return true
			return Array.from( transfer.items ?? [] ).some( item => item.kind === 'file' )
		}

		file_drag_inside_map( event: DragEvent ) {
			const target = event.target
			if( !( target instanceof Node ) ) return false
			return this.Pane().dom_node().contains( target )
		}

		file_dragover_document( event: DragEvent ) {
			if( !this.file_drag_inside_map( event ) ) return
			if( !this.file_drag_has_files( event ) ) return
			event.preventDefault()
			event.stopPropagation()
			event.stopImmediatePropagation()
			if( event.dataTransfer ) event.dataTransfer.dropEffect = 'copy'
		}

		file_drop_document( event: DragEvent ) {
			if( !this.file_drag_inside_map( event ) ) return
			if( !this.file_drag_has_files( event ) ) return
			event.preventDefault()
			event.stopPropagation()
			event.stopImmediatePropagation()
			this.event_drop( event )
		}

		@ $mol_mem
		file_dragover_document_listener() {
			this.file_dragover_document_listener_obj?.destructor()
			this.file_dragover_document_listener_obj = new $mol_dom_listener(
				this.document(),
				'dragover',
				event => this.file_dragover_document( event as DragEvent ),
				{ passive: false, capture: true } as any,
			)
			return this.file_dragover_document_listener_obj
		}

		@ $mol_mem
		file_drop_document_listener() {
			this.file_drop_document_listener_obj?.destructor()
			this.file_drop_document_listener_obj = new $mol_dom_listener(
				this.document(),
				'drop',
				event => this.file_drop_document( event as DragEvent ),
				{ passive: false, capture: true } as any,
			)
			return this.file_drop_document_listener_obj
		}

		@ $mol_mem
		keydown_handler() {
			return $mol_wire_async(( event: KeyboardEvent )=>{
				if( event.defaultPrevented ) return
				if( this.overlayed() ) return

				const slideshow_key = this.$.$shm_hitalama_settings.slideshow_mode_key()
				const drawing_key = this.$.$shm_hitalama_settings.drawing_mode_key()
				if( event.key == 'Delete' ) {

					if( $shm_hitalama_is_input_focused() ) return
					
					const links = this.selected_links()
					links.forEach( r => {
						this.map().widget_cut( r ) 
					} )
					this.selected_links([])
					
				}
				else if( slideshow_key && event.key == slideshow_key ) {
					this.slideshow_enabled( !this.slideshow_enabled() )
				}
				else if( drawing_key && this.hotkey_matches( event, drawing_key ) ) {
					// if( $shm_hitalama_is_input_focused() ) return
					// event.preventDefault()
					// this.tool_mode( this.tool_mode() === 'drawing' ? '' : 'drawing' )
				}
				else if( event.key == 'ArrowLeft' || event.key == 'PageUp' ) {
					this.slideshow_frame( this.slideshow_frame() - 1 )
				}
				else if( event.key == 'ArrowRight' || event.key == 'PageDown' ) {
					this.slideshow_frame( this.slideshow_frame() + 1 )
				}
			})
		}

		@ $mol_action
		copy_selected_widgets( event: KeyboardEvent ) {
			if( this.overlayed() ) return
			if( $mol_view_selection.focused()[0].id.endsWith(`Result_row()`) ) return
			if( !$mol_view_selection.focused()[0].id.startsWith(`$${''}hitalama_app.Root(0).Maps().Book`) ) return
			if( $shm_hitalama_is_input_focused() ) return
			
			const refs = this.selected_links()
			const widgets = refs.map( r => this.widget_by_link( r ) )
			if( widgets.length == 0 ) return

			event.preventDefault()
			const serialized = this.map().serialize_widgets( widgets )
			navigator.clipboard.writeText( JSON.stringify( serialized ) )
		}

		hotkey_matches( event: KeyboardEvent, key: string ) {
			if( event.ctrlKey || event.altKey || event.metaKey ) return false

			const expected = key.trim()
			if( !expected ) return false

			const event_key = event.key.toLowerCase()
			const expected_key = expected.toLowerCase()
			if( event_key === expected_key ) return true

			if( expected_key === 'p' && ( event.code === 'KeyP' || event_key === 'з' ) ) return true
			if( expected_key === 'з' && ( event.code === 'KeyP' || event_key === 'p' ) ) return true

			return false
		}

		@ $mol_mem
		keydown_handler_nopassive() {
			return $mol_wire_async(( event: KeyboardEvent )=>{
				if( event.code == 'KeyC' && event.ctrlKey ) {
					this.copy_selected_widgets( event )
				}
				if( event.code == 'KeyG' && event.ctrlKey ) {
					event.preventDefault()
					if( event.shiftKey ) this.ungrouping()
					else this.grouping()
				}
			})
		}

		ungrouping() {
			const links = this.selected_links()
			// if( links.length != 1 ) return
			// const bb = get_bounding_box( links.map( l => this.Widget(l).Sub() as $shm_hitalama_map_widget_float ) )

			const ungroupped: $giper_baza_link[] = []
			links.forEach( link => {
				const group = this.widget_by_link( link )
				if( group.type() != 'group' ) return

				const widgets = group?.widgets()
				widgets.forEach( w => {
					w.container_widget( null )
					ungroupped.push( w.link() )
				} )
				group.widgets( [] )
				this.map().widget_cut( group.link() )
			} )
			this.selected_links( ungroupped )
		}

		grouping() {
			const links = this.grouping_links()
			if( links.length < 2 ) return

			const container = this.grouping_container( links )
			const widgets_ordered = ( this.map().Widgets_list()?.remote_list() ?? [] ) as readonly $shm_hitalama_map_widget[]
			const grouped_links = new Set(
				links.flatMap( link => this.widget_by_link( link ).z_block().map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
			)
			const top_index = Math.max(
				... widgets_ordered.flatMap( ( widget, index ) =>
					grouped_links.has( widget.link_str() ) ? [ index ] : []
				)
			)
			const insert_index = widgets_ordered.reduce( ( count: number, widget: $shm_hitalama_map_widget, index: number ) =>
				index <= top_index && !grouped_links.has( widget.link_str() ) ? count + 1 : count
			, 0 )

			const bb = get_bounding_box( links.map( l => this.Widget(l).Sub() as $shm_hitalama_map_widget_float ) )

			const group = this.map().widget_add( 'group', [bb.left, bb.top], bb.width, bb.height )!
			this.grouping_extract( links )
			if( container ) {
				group.container_widget( container )
				this.grouping_container_place( container, group, links )
			}
			group?.widgets( links.map( l => {
				const w = this.widget_by_link( l )
				w.container_widget( group )
				return w
			} ) )
			this.grouping_z_place( group, grouped_links, insert_index )
			this.selected_links( [group.link()] )
			// this.map().Widgets()?.add(group.link())
			// this.widget_to_bottom( group.link() )
		}

		grouping_container( links: readonly $giper_baza_link[] ) {
			const containers = links.map( link => this.widget_by_link( link ).container_widget() )
			const first = containers[0]
			if( !first ) return null
			return containers.every( container => container?.link_str() === first.link_str() ) ? first : null
		}

		grouping_extract( links: readonly $giper_baza_link[] ) {
			links.forEach( link => this.map().widget_detach( link ) )
		}

		grouping_container_place(
			container: $shm_hitalama_map_widget,
			group: $shm_hitalama_map_widget,
			links: readonly $giper_baza_link[],
		) {
			const selected = new Set( links.map( link => link.str ) )
			let inserted = false
			const widgets = container.widgets().flatMap( widget => {
				if( !selected.has( widget.link_str() ) ) return [ widget ]
				if( inserted ) return []
				inserted = true
				return [ group ]
			} )
			container.widgets( inserted ? widgets : [ ... widgets, group ] )
		}

		grouping_z_place( group: $shm_hitalama_map_widget, grouped_links: Set< string >, insert_index: number ) {
			const list = this.map().Widgets_list(null)
			const widgets = list?.remote_list() ?? []
			const group_link = group.link_str()
			const next_widgets = widgets.filter( ( widget: $shm_hitalama_map_widget ) => {
				const link = widget.link_str()
				return link !== group_link && !grouped_links.has( link )
			} )
			const block = [
				group,
				... widgets.filter( ( widget: $shm_hitalama_map_widget ) => grouped_links.has( widget.link_str() ) ),
			]
			next_widgets.splice( insert_index, 0, ... block )
			list?.remote_list( next_widgets as any )
		}

		grouping_links() {
			const links = this.selected_links()
			const selected = new Set( links.map( l => l.str ) )

			return links.filter( link => {
				let parent = this.widget_by_link( link ).container_widget()
				while( parent ) {
					if( selected.has( parent.link_str() ) ) return false
					parent = parent.container_widget()
				}
				return true
			} )
		}

		// @ $mol_mem
		// keydown_listener() {
		// 	return new $mol_dom_listener(
		// 		this.$.$mol_dom_context.document,
		// 		'keydown',
		// 		$mol_wire_async( (event: KeyboardEvent) => {
		// 			this.keydown_handler( event )
		// 		} ),
		// 		{
		// 			passive: false
		// 		},
		// 	)
		// }

		transfer_widget_render_data( node: $shm_hitalama_transfer_node ) {
			const field = node.fields.Render_data
			if( field?.kind !== 'atom' ) return null
			const value = field.value
			if( !value || typeof value !== 'object' ) return null
			return value as {
				body_x: number
				body_y: number
				right_edge_x: number
				bottom_edge_y: number
			}
		}

		transfer_widget_class( class_name: string | undefined ) {
			return class_name === '$shm_hitalama_map_widget' || class_name === '$' + 'hitalama_map_widget'
		}

		deserialize_below_pointer( dto: ReturnType< $shm_hitalama_map["serialize_widgets"] > ) {
			const pointer_pos = this.get_pointer_pos()
			const widgets = dto.nodes.filter(
				(node): node is $shm_hitalama_transfer_node & {
					class_name: string
					fields: Record< string, $shm_hitalama_transfer_field >
				} => this.transfer_widget_class( node.class_name )
			)

			let left = Infinity
			let top = Infinity
			
			let right = -Infinity
			let bottom = -Infinity

			widgets.forEach( node => {
				const render_data = this.transfer_widget_render_data( node )
				if( !render_data ) return

				left = Math.min( left, render_data.body_x )
				top = Math.min( top, render_data.body_y )

				right = Math.max( right, render_data.body_x + render_data.right_edge_x )
				bottom = Math.max( bottom, render_data.body_y + render_data.bottom_edge_y )
			} )

			if( !Number.isFinite( left ) || !Number.isFinite( top ) ) {
				this.map().deserialize_widgets( dto )
				return
			}

			const width = right - left
			const height = bottom - top
			
			const offset_x = pointer_pos[0] - left - width/2
			const offset_y = pointer_pos[1] - top - height/2

			const dto_translated = {
				...dto,
				nodes: dto.nodes.map( node => {
					if( !this.transfer_widget_class( node.class_name ) ) return node

					const render_data = this.transfer_widget_render_data( node )
					if( !render_data ) return node
					const Render_data = node.fields.Render_data

					return {
						...node,
						fields: {
							...node.fields,
							Render_data: Render_data?.kind === 'atom'
								? {
									...Render_data,
									value: {
										...render_data,
										body_x: render_data.body_x + offset_x,
										body_y: render_data.body_y + offset_y,
									},
								}
								: Render_data,
						},
					}
				} )
			}

			const old_links = new Set( this.map().Widgets_list()?.remote_list().map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) ?? [] )
			this.map().deserialize_widgets( dto_translated )
			const new_links = this.map().Widgets_list()?.remote_list()
				.filter( ( widget: $shm_hitalama_map_widget ) => !old_links.has( widget.link_str() ) )
				.map( ( widget: $shm_hitalama_map_widget ) => widget.link() ) ?? []
			if( new_links.length ) this.selected_links( new_links )
		}

		@ $mol_mem
		paste_handler() {
			return $mol_wire_async( (event: ClipboardEvent) => {
				if( $shm_hitalama_is_input_focused() ) return

				const items = ( event.clipboardData || (event as any).originalEvent.clipboardData ).items
				for( let index in items ) {
					const item = items[ index ]
					if( item.type === 'text/plain' ) {
						item.getAsString( ( str: string) => {

							try {
								const dto = JSON.parse( str )
								$mol_wire_async( this ).deserialize_below_pointer( dto )
							} catch (error) {
								$mol_wire_async( this ).paste_text( str )
							}

						} )
					}
					if( item.kind === 'file' ) {
						const blob = item.getAsFile()
						if( !blob ) continue
						this.image_add_pasted( blob ).catch( error => {
							if( !$mol_promise_like( error ) ) console.error( error )
						} )
					}
				}
			} )
		}
		
		window() {
			return window
		}

		@ $mol_mem
		resize_handler() {
			return $mol_wire_async( (event: Event) => {
				this.viewport_to_frame( null )
			} )
		}

	}

	function get_bounding_box( widgets: $shm_hitalama_map_widget_float[] ) {
		const bounds = widgets.reduce( ( acc, w ) => ( {
			minLeft: Math.min( acc.minLeft, w.left() ),
			minTop: Math.min( acc.minTop, w.top() ),
			maxRight: Math.max( acc.maxRight, w.left() + w.width() ),
			maxBottom: Math.max( acc.maxBottom, w.top() + w.height() )
		} ), {
			minLeft: Infinity,
			minTop: Infinity,
			maxRight: -Infinity,
			maxBottom: -Infinity
		} )

		return {
			left: bounds.minLeft,
			top: bounds.minTop,
			width: bounds.maxRight - bounds.minLeft,
			height: bounds.maxBottom - bounds.minTop
		}
	}

}
